var map = {
	"./bian.png": "./src/assets/images/map/bian.png",
	"./bluexx.png": "./src/assets/images/map/bluexx.png",
	"./car-icon.png": "./src/assets/images/map/car-icon.png",
	"./clz.png": "./src/assets/images/map/clz.png",
	"./cq.png": "./src/assets/images/map/cq.png",
	"./ctycxc.png": "./src/assets/images/map/ctycxc.png",
	"./dt-new.png": "./src/assets/images/map/dt-new.png",
	"./dt.png": "./src/assets/images/map/dt.png",
	"./dt1.png": "./src/assets/images/map/dt1.png",
	"./end-icon.png": "./src/assets/images/map/end-icon.png",
	"./env.png": "./src/assets/images/map/env.png",
	"./fpxm.png": "./src/assets/images/map/fpxm.png",
	"./granary_base.png": "./src/assets/images/map/granary_base.png",
	"./granary_lt.png": "./src/assets/images/map/granary_lt.png",
	"./gy.png": "./src/assets/images/map/gy.png",
	"./gy/右上.png": "./src/assets/images/map/gy/右上.png",
	"./gy/右下.png": "./src/assets/images/map/gy/右下.png",
	"./gy/左上.png": "./src/assets/images/map/gy/左上.png",
	"./gy/左下.png": "./src/assets/images/map/gy/左下.png",
	"./gy/根子柏桥贡园.png": "./src/assets/images/map/gy/根子柏桥贡园.png",
	"./gy/根子柏桥贡园1.png": "./src/assets/images/map/gy/根子柏桥贡园1.png",
	"./gy/泗水滩底贡园.png": "./src/assets/images/map/gy/泗水滩底贡园.png",
	"./gy/泗水滩底贡园1.png": "./src/assets/images/map/gy/泗水滩底贡园1.png",
	"./gy/羊角禄段贡园.png": "./src/assets/images/map/gy/羊角禄段贡园.png",
	"./gy/羊角禄段贡园1.png": "./src/assets/images/map/gy/羊角禄段贡园1.png",
	"./gy/霞洞上河贡园.png": "./src/assets/images/map/gy/霞洞上河贡园.png",
	"./gy/霞洞上河贡园1.png": "./src/assets/images/map/gy/霞洞上河贡园1.png",
	"./gy2.png": "./src/assets/images/map/gy2.png",
	"./htyz10.png": "./src/assets/images/map/htyz10.png",
	"./htyz2.png": "./src/assets/images/map/htyz2.png",
	"./htzz1.png": "./src/assets/images/map/htzz1.png",
	"./hzs.png": "./src/assets/images/map/hzs.png",
	"./ico_djd.png": "./src/assets/images/map/ico_djd.png",
	"./ico_kjzx.png": "./src/assets/images/map/ico_kjzx.png",
	"./ico_lx.png": "./src/assets/images/map/ico_lx.png",
	"./ico_yd.png": "./src/assets/images/map/ico_yd.png",
	"./ico_yh.png": "./src/assets/images/map/ico_yh.png",
	"./ico_ylq.png": "./src/assets/images/map/ico_ylq.png",
	"./icon_all.png": "./src/assets/images/map/icon_all.png",
	"./icon_complete.png": "./src/assets/images/map/icon_complete.png",
	"./icon_complete_c.png": "./src/assets/images/map/icon_complete_c.png",
	"./icon_const.png": "./src/assets/images/map/icon_const.png",
	"./icon_const_c.png": "./src/assets/images/map/icon_const_c.png",
	"./icon_cy.png": "./src/assets/images/map/icon_cy.png",
	"./icon_cyrh.png": "./src/assets/images/map/icon_cyrh.png",
	"./icon_cyrh_c.png": "./src/assets/images/map/icon_cyrh_c.png",
	"./icon_dk.png": "./src/assets/images/map/icon_dk.png",
	"./icon_dktx.png": "./src/assets/images/map/icon_dktx.png",
	"./icon_dktx_c.png": "./src/assets/images/map/icon_dktx_c.png",
	"./icon_first.png": "./src/assets/images/map/icon_first.png",
	"./icon_first_c.png": "./src/assets/images/map/icon_first_c.png",
	"./icon_fourth.png": "./src/assets/images/map/icon_fourth.png",
	"./icon_fourth_c.png": "./src/assets/images/map/icon_fourth_c.png",
	"./icon_ggqy.png": "./src/assets/images/map/icon_ggqy.png",
	"./icon_ggqy_c.png": "./src/assets/images/map/icon_ggqy_c.png",
	"./icon_hgc.png": "./src/assets/images/map/icon_hgc.png",
	"./icon_jgc_wxz.png": "./src/assets/images/map/icon_jgc_wxz.png",
	"./icon_jgc_xz.png": "./src/assets/images/map/icon_jgc_xz.png",
	"./icon_kj.png": "./src/assets/images/map/icon_kj.png",
	"./icon_kjxx.png": "./src/assets/images/map/icon_kjxx.png",
	"./icon_kjxx_c.png": "./src/assets/images/map/icon_kjxx_c.png",
	"./icon_lndn.png": "./src/assets/images/map/icon_lndn.png",
	"./icon_noconst.png": "./src/assets/images/map/icon_noconst.png",
	"./icon_noconst_c.png": "./src/assets/images/map/icon_noconst_c.png",
	"./icon_nyss.png": "./src/assets/images/map/icon_nyss.png",
	"./icon_nyss_c.png": "./src/assets/images/map/icon_nyss_c.png",
	"./icon_project.png": "./src/assets/images/map/icon_project.png",
	"./icon_qb.png": "./src/assets/images/map/icon_qb.png",
	"./icon_qt.png": "./src/assets/images/map/icon_qt.png",
	"./icon_qt_c.png": "./src/assets/images/map/icon_qt_c.png",
	"./icon_qxz.png": "./src/assets/images/map/icon_qxz.png",
	"./icon_qxz_c.png": "./src/assets/images/map/icon_qxz_c.png",
	"./icon_second.png": "./src/assets/images/map/icon_second.png",
	"./icon_second_c.png": "./src/assets/images/map/icon_second_c.png",
	"./icon_sgz.png": "./src/assets/images/map/icon_sgz.png",
	"./icon_slc_wxz.png": "./src/assets/images/map/icon_slc_wxz.png",
	"./icon_slc_xz.png": "./src/assets/images/map/icon_slc_xz.png",
	"./icon_sszt.png": "./src/assets/images/map/icon_sszt.png",
	"./icon_sszt_qt.png": "./src/assets/images/map/icon_sszt_qt.png",
	"./icon_subject.png": "./src/assets/images/map/icon_subject.png",
	"./icon_td.png": "./src/assets/images/map/icon_td.png",
	"./icon_tdlz.png": "./src/assets/images/map/icon_tdlz.png",
	"./icon_tdlz_c.png": "./src/assets/images/map/icon_tdlz_c.png",
	"./icon_third.png": "./src/assets/images/map/icon_third.png",
	"./icon_third_c.png": "./src/assets/images/map/icon_third_c.png",
	"./icon_time.png": "./src/assets/images/map/icon_time.png",
	"./icon_wkg.png": "./src/assets/images/map/icon_wkg.png",
	"./icon_yd.png": "./src/assets/images/map/icon_yd.png",
	"./icon_ywg.png": "./src/assets/images/map/icon_ywg.png",
	"./icon_zhsx.png": "./src/assets/images/map/icon_zhsx.png",
	"./icon_zhsx_c.png": "./src/assets/images/map/icon_zhsx_c.png",
	"./icon_zq.png": "./src/assets/images/map/icon_zq.png",
	"./icon_zq_min.png": "./src/assets/images/map/icon_zq_min.png",
	"./icon_zzc_wxz.png": "./src/assets/images/map/icon_zzc_wxz.png",
	"./icon_zzc_xz.png": "./src/assets/images/map/icon_zzc_xz.png",
	"./jgqy.png": "./src/assets/images/map/jgqy.png",
	"./jiao.png": "./src/assets/images/map/jiao.png",
	"./jpyc11.png": "./src/assets/images/map/jpyc11.png",
	"./jpyc8.png": "./src/assets/images/map/jpyc8.png",
	"./jtnc.png": "./src/assets/images/map/jtnc.png",
	"./jyzt.png": "./src/assets/images/map/jyzt.png",
	"./ks.png": "./src/assets/images/map/ks.png",
	"./lbyc12.png": "./src/assets/images/map/lbyc12.png",
	"./lbyc7.png": "./src/assets/images/map/lbyc7.png",
	"./ld/10.png": "./src/assets/images/map/ld/10.png",
	"./ld/11.png": "./src/assets/images/map/ld/11.png",
	"./ld/12.png": "./src/assets/images/map/ld/12.png",
	"./ld/7.png": "./src/assets/images/map/ld/7.png",
	"./ld/8.png": "./src/assets/images/map/ld/8.png",
	"./ld/9.png": "./src/assets/images/map/ld/9.png",
	"./ld/bg.png": "./src/assets/images/map/ld/bg.png",
	"./ld/ico_ck1.png": "./src/assets/images/map/ld/ico_ck1.png",
	"./ld/ico_ck2.png": "./src/assets/images/map/ld/ico_ck2.png",
	"./ld/ico_jg1.png": "./src/assets/images/map/ld/ico_jg1.png",
	"./ld/ico_jg2.png": "./src/assets/images/map/ld/ico_jg2.png",
	"./ld/ico_ll1.png": "./src/assets/images/map/ld/ico_ll1.png",
	"./ld/ico_ll2.png": "./src/assets/images/map/ld/ico_ll2.png",
	"./ld/ico_ry.png": "./src/assets/images/map/ld/ico_ry.png",
	"./ld/ico_wl1.png": "./src/assets/images/map/ld/ico_wl1.png",
	"./ld/ico_wl2.png": "./src/assets/images/map/ld/ico_wl2.png",
	"./ld/l-01.png": "./src/assets/images/map/ld/l-01.png",
	"./ld/l-02.png": "./src/assets/images/map/ld/l-02.png",
	"./ld/l-03.png": "./src/assets/images/map/ld/l-03.png",
	"./ld/l-04.png": "./src/assets/images/map/ld/l-04.png",
	"./ld/l-05.png": "./src/assets/images/map/ld/l-05.png",
	"./ld/l-06.png": "./src/assets/images/map/ld/l-06.png",
	"./ld/l-07.png": "./src/assets/images/map/ld/l-07.png",
	"./ld/l-08.png": "./src/assets/images/map/ld/l-08.png",
	"./ld/l-09.png": "./src/assets/images/map/ld/l-09.png",
	"./ld/l-10.png": "./src/assets/images/map/ld/l-10.png",
	"./ld/l-11.png": "./src/assets/images/map/ld/l-11.png",
	"./ld/l-12.png": "./src/assets/images/map/ld/l-12.png",
	"./ld/liugey.png": "./src/assets/images/map/ld/liugey.png",
	"./ld/liugey2.png": "./src/assets/images/map/ld/liugey2.png",
	"./ld/liugeyi.png": "./src/assets/images/map/ld/liugeyi.png",
	"./ld/liugeyi2.png": "./src/assets/images/map/ld/liugeyi2.png",
	"./ld/nav-bg.png": "./src/assets/images/map/ld/nav-bg.png",
	"./ld/中国荔枝产业大会.png": "./src/assets/images/map/ld/中国荔枝产业大会.png",
	"./ld/中国荔枝产业大会1.png": "./src/assets/images/map/ld/中国荔枝产业大会1.png",
	"./ld/中国荔枝产业大会会址.png": "./src/assets/images/map/ld/中国荔枝产业大会会址.png",
	"./ld/中国荔枝博物馆.png": "./src/assets/images/map/ld/中国荔枝博物馆.png",
	"./ld/中国荔枝博物馆1.png": "./src/assets/images/map/ld/中国荔枝博物馆1.png",
	"./ld/中国荔枝博览馆.png": "./src/assets/images/map/ld/中国荔枝博览馆.png",
	"./ld/五化果园.png": "./src/assets/images/map/ld/五化果园.png",
	"./ld/产业园信息管理平台.png": "./src/assets/images/map/ld/产业园信息管理平台.png",
	"./ld/产业园信息管理平台1.png": "./src/assets/images/map/ld/产业园信息管理平台1.png",
	"./ld/产业园信息管理平台2.png": "./src/assets/images/map/ld/产业园信息管理平台2.png",
	"./ld/右上.png": "./src/assets/images/map/ld/右上.png",
	"./ld/右下.png": "./src/assets/images/map/ld/右下.png",
	"./ld/右下0.png": "./src/assets/images/map/ld/右下0.png",
	"./ld/向下.png": "./src/assets/images/map/ld/向下.png",
	"./ld/国家荔枝种质资源圃.png": "./src/assets/images/map/ld/国家荔枝种质资源圃.png",
	"./ld/国家荔枝种质资源圃1.png": "./src/assets/images/map/ld/国家荔枝种质资源圃1.png",
	"./ld/左上.png": "./src/assets/images/map/ld/左上.png",
	"./ld/左下.png": "./src/assets/images/map/ld/左下.png",
	"./ld/智慧荔园.png": "./src/assets/images/map/ld/智慧荔园.png",
	"./ld/智慧荔园1.png": "./src/assets/images/map/ld/智慧荔园1.png",
	"./ld/根子柏桥贡园.png": "./src/assets/images/map/ld/根子柏桥贡园.png",
	"./ld/泗水滩底古荔园.png": "./src/assets/images/map/ld/泗水滩底古荔园.png",
	"./ld/泗水滩底贡园.png": "./src/assets/images/map/ld/泗水滩底贡园.png",
	"./ld/田头小站.png": "./src/assets/images/map/ld/田头小站.png",
	"./ld/羊角禄段古荔园.png": "./src/assets/images/map/ld/羊角禄段古荔园.png",
	"./ld/羊角禄段贡园.png": "./src/assets/images/map/ld/羊角禄段贡园.png",
	"./ld/霞洞上河古荔园.png": "./src/assets/images/map/ld/霞洞上河古荔园.png",
	"./ld/霞洞上河贡园.png": "./src/assets/images/map/ld/霞洞上河贡园.png",
	"./line.png": "./src/assets/images/map/line.png",
	"./ltqy.png": "./src/assets/images/map/ltqy.png",
	"./ltz.png": "./src/assets/images/map/ltz.png",
	"./lzzz1.png": "./src/assets/images/map/lzzz1.png",
	"./market.png": "./src/assets/images/map/market.png",
	"./nj.png": "./src/assets/images/map/nj.png",
	"./njd.png": "./src/assets/images/map/njd.png",
	"./nq.png": "./src/assets/images/map/nq.png",
	"./nzjyqy.png": "./src/assets/images/map/nzjyqy.png",
	"./p.png": "./src/assets/images/map/p.png",
	"./pest.old.png": "./src/assets/images/map/pest.old.png",
	"./pest.png": "./src/assets/images/map/pest.png",
	"./pest_min.png": "./src/assets/images/map/pest_min.png",
	"./pig.png": "./src/assets/images/map/pig.png",
	"./qiyun.png": "./src/assets/images/map/qiyun.png",
	"./qx.png": "./src/assets/images/map/qx.png",
	"./replay.png": "./src/assets/images/map/replay.png",
	"./scjd.png": "./src/assets/images/map/scjd.png",
	"./sfgy.png": "./src/assets/images/map/sfgy.png",
	"./sfldc.png": "./src/assets/images/map/sfldc.png",
	"./slccj.png": "./src/assets/images/map/slccj.png",
	"./soil.png": "./src/assets/images/map/soil.png",
	"./sp.png": "./src/assets/images/map/sp.png",
	"./speed.png": "./src/assets/images/map/speed.png",
	"./spjgc.png": "./src/assets/images/map/spjgc.png",
	"./spjgcxc.png": "./src/assets/images/map/spjgcxc.png",
	"./sq.png": "./src/assets/images/map/sq.png",
	"./start-icon.png": "./src/assets/images/map/start-icon.png",
	"./task-bg.png": "./src/assets/images/map/task-bg.png",
	"./task-line.png": "./src/assets/images/map/task-line.png",
	"./task-title-bg.png": "./src/assets/images/map/task-title-bg.png",
	"./video.png": "./src/assets/images/map/video.png",
	"./weather.png": "./src/assets/images/map/weather.png",
	"./wqy.png": "./src/assets/images/map/wqy.png",
	"./wtyc9.png": "./src/assets/images/map/wtyc9.png",
	"./x1.png": "./src/assets/images/map/x1.png",
	"./x2.png": "./src/assets/images/map/x2.png",
	"./x4.png": "./src/assets/images/map/x4.png",
	"./x8.png": "./src/assets/images/map/x8.png",
	"./ycyp.png": "./src/assets/images/map/ycyp.png",
	"./yelxx.png": "./src/assets/images/map/yelxx.png",
	"./ymzxc.png": "./src/assets/images/map/ymzxc.png",
	"./ywc.png": "./src/assets/images/map/ywc.png",
	"./yzc.png": "./src/assets/images/map/yzc.png",
	"./zc.png": "./src/assets/images/map/zc.png",
	"./zt.png": "./src/assets/images/map/zt.png",
	"./zzdh.png": "./src/assets/images/map/zzdh.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/map sync recursive ^\\.\\/.*\\.png$";